// CSV of a QuickBooks reconciliation report (GET /api/quickbooks/invoices/reconcile/).
// Same columns as the server's `qbo_invoice_reconcile --csv`, so a file from
// the page and a file from the command can be compared line for line.

export const RECONCILE_CSV_HEADERS = [
  "section", "match", "cz_id", "cz_number", "cz_date", "cz_status", "cz_client",
  "cz_pretax", "cz_tax", "cz_total", "qbo_id", "qbo_doc_number", "qbo_date",
  "qbo_customer", "qbo_pretax", "qbo_tax", "qbo_total", "qbo_balance",
  "diff_total", "note",
];

const cell = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const czCols = (c) =>
  c
    ? [c.id, c.number, c.date, c.status, c.client_name, c.pretax, c.tax, c.total]
    : ["", "", "", "", "", "", "", ""];

const qCols = (q) =>
  q
    ? [q.qbo_id, q.doc_number, q.date, q.customer_name, q.pretax, q.tax, q.total, q.balance]
    : ["", "", "", "", "", "", "", ""];

export function reconcileCsv(report) {
  const rows = [];
  (report.only_in_quickbooks || []).forEach((q) =>
    rows.push(["only_in_quickbooks", "", ...czCols(null), ...qCols(q), "", q.note]));
  (report.only_in_clientzone || []).forEach((c) =>
    rows.push(["only_in_clientzone", "", ...czCols(c), ...qCols(null), "", c.note]));
  (report.matched || []).forEach((m) => {
    const differs = m.diff_total !== "0.00" || m.diff_pretax !== "0.00";
    rows.push([
      differs ? "amount_difference" : "matched", m.how, ...czCols(m.cz), ...qCols(m.qbo),
      m.diff_total, m.date_differs ? "dates differ" : "",
    ]);
  });
  (report.drafts || []).forEach((c) =>
    rows.push(["draft_in_range", "", ...czCols(c), ...qCols(null), "", ""]));
  (report.credit_memos || []).forEach((q) =>
    rows.push(["qbo_credit_memo", "", ...czCols(null), ...qCols(q), "", ""]));
  return [RECONCILE_CSV_HEADERS, ...rows].map((r) => r.map(cell).join(",")).join("\n") + "\n";
}
